<template>
    <div id="tabList">
        <ul class="tabList">
            <li class="pointer left" @click="checkActive(list)" :class="{'active': list.active}" v-for="(list, index) in list" :key="index" v-show='list.isShow'>
                {{list.title}}
                <div class="icon" @click.stop="closeList(list, index)">
                    <i class="el-icon-close "></i><i class="el-icon-error color-blue"></i>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'tabList',
        data () {
            return {
                list: this.$root.openNav
            }
        },
        methods: {
            checkActive (item, opera) {//‘opera’参数为是否刷新，有值为手动刷新页面，为空时为点击页面触发路由跳转
                this.$root.Permission.forEach(el => { //初始化值，所有变为为打开状态
                    el.active = false
                    el.item.forEach(el1 => {
                        el1.active = false
                        el1.item.forEach(el2 => {
                            el2.active = false
                        });
                    });
                });

                this.$root.Permission.forEach(el => { //循环判断，改变当前值为打开状态
                    if (JSON.stringify(el).indexOf(item.id) >= 0) {
                        el.active = true
                        el.item.forEach(el1 => {
                            if (JSON.stringify(el1).indexOf(item.id) >= 0) {
                                el1.active = true
                                el1.item.forEach(el2 => {
                                    if (JSON.stringify(el2).indexOf(item.id) >= 0) {
                                        el2.active = true
                                        return
                                    }
                                });
                                return
                            }
                        });
                        return
                    }
                });
                this.$root.openNav.forEach(el => {//初始化已打开列表为隐藏状态
                    el.active = false
                })
                item.active = true//修改当前值为显示状态
                if (!opera) { //‘opera’参数为是否刷新，有值为手动刷新页面不进行路由跳转，为空时为点击页面则触发路由跳转
                    this.goPath(item.chirld || item.url)
                }
            },
            clearList (itme) {
                this.$root.Permission.forEach(el => {
                    el.item.forEach(el1 => {
                        el1.item.forEach(el2 => {
                            el2.active = false
                        })
                    });
                });
                this.$router.push({path: '/index'})
            },
            closeList (item, index) {
                if (item.active) {
                    if (index > 0) {
                        this.checkActive(this.list[index - 1])
                    } else {
                        this.clearList(item)
                    }
                }
                this.list.splice(index, 1)
            }
        },
        mounted () {
            this.$root.Permission.forEach(el => {
                el.item.forEach(el1 => {
                    el1.item.forEach(el2 => {
                        if (this.$route.path.indexOf(el2.url) !== -1) {
                            this.checkActive(el2, 'update') //'update'表示刷新
                            return
                        }
                    })
                })
            })
        }
    }
</script>
<style scoped>
#tabList{width: 100%;height: 42px;}
#tabList .tabList{width: 100%;height: 42px;line-height: 42px; background: #F2F5FA;}
#tabList .tabList li{padding: 0 15px;}
#tabList .tabList li .icon{display: inline-block;width: 20px;height: 20px;position: relative;margin: 0 0 -5px 0;}
#tabList .tabList li .icon i{position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);}
#tabList .tabList li .icon .el-icon-close{font-size: 10px;z-index: 1;}
#tabList .tabList li .icon .el-icon-error{font-size: 16px;z-index: 2;display: none;}
#tabList .tabList li .icon:hover .el-icon-close{display: none;}
#tabList .tabList li .icon:hover .el-icon-error{display: block;}
#tabList .tabList li.active{background: #fff;}
#tabList .tabList li:hover{background: #fff;}
</style>


// WEBPACK FOOTER //
// src/components/tabList.vue